import { Directive, Input } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../pages/base-mortgage-application.component';
import { Applicant } from './../../models/applicant.model';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Directive()
export abstract class BaseApplicantComponent extends BaseMortgageApplicationComponent {
  @Input() applicant: Applicant;
  @Input() applicantIndex: number;

  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
